import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { VbUiSidebarLayoutComponent } from './VbUiSidebarLayout.Component';
import { VbUiSidebarComponent } from './VbUiSidebar.Component';
import { VbUiSidebarButtonComponent } from './VbUiSidebarButton.Component';
import { CssRulesAngularModule } from '../css/Css.AngularModule';

const components = [
	VbUiSidebarComponent,
	VbUiSidebarLayoutComponent,
	VbUiSidebarButtonComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		CssRulesAngularModule,
		TooltipModule,
		TranslateModule,
		UIRouterModule
	]
})
export class SidebarLayoutModule {}
